// Словарь страницы КП для клиента (`apps/portal`). Отдельным файлом: страница грузит только его
// (`@glory/i18n/portal`), а не весь словарь платформы; в `ru.ts` он подключён разделом `portal`.

export const ruPortal = {
  app: {
    title: 'Коммерческое предложение',
    loading: 'Загружаем предложение…',
  },
  cover: {
    kicker: 'Коммерческое предложение',
    title: 'Предложение для {client}',
    number: '{label} от {date}',
    draft: 'Черновик от {date}',
    validUntil: 'Действует до {date}',
    pdf: 'Скачать PDF',
    pdfShort: 'PDF',
  },
  preview: {
    title: 'Предпросмотр',
    body: 'Так клиент увидит предложение. Ответы отсюда не отправляются, открытия не считаются.',
  },
  states: {
    expiredTitle: 'Предложение истекло',
    expiredBody: 'Цены и сроки действовали до {date}. Попросите актуальное — менеджер пришлёт свежую версию.',
    renew: 'Запросить актуальное',
    renewSent: 'Запрос отправлен — менеджер пришлёт актуальное предложение',
    supersededTitle: 'Есть обновлённое предложение',
    supersededBody: 'Студия обновила предложение — откройте новую версию {label}.',
    supersededNoLink: 'Студия обновила предложение — свяжитесь с менеджером, он пришлёт ссылку.',
    openNewer: 'Открыть обновлённое',
    revokedTitle: 'Предложение отозвано',
    revokedBody: 'Ссылка больше не действует. Если предложение всё ещё нужно — свяжитесь с менеджером.',
    notFoundTitle: 'Ссылка не найдена',
    notFoundBody: 'Проверьте адрес или попросите менеджера прислать ссылку ещё раз.',
    errorTitle: 'Не удалось загрузить предложение',
    networkError: 'Нет связи с сервером — проверьте интернет и повторите',
    retry: 'Повторить',
  },
  sections: {
    understanding: 'Понимание задачи',
    packages: 'Пакеты',
    package: 'Стоимость',
    stages: 'Этапы и сроки',
    support: 'Поддержка после запуска',
    payment: 'График оплат',
    cases: 'Кейсы',
    manager: 'Ваш менеджер',
    about: 'О студии',
  },
  packages: {
    recommended: 'Рекомендуем',
    includes: 'Что входит',
    term: '{days}',
    termHint:
      'Срок — в рабочих днях от старта работ, с запасом. Этапы могут идти параллельно, поэтому срок меньше суммы этапов.',
    discount: '−{percent} {label}',
    discountPlain: 'Скидка {percent}',
    rangeFrom: 'от {from}',
    range: '{from} – {to}',
    rangeHint:
      'Работа по часам: итог зависит от фактически затраченного времени. Здесь — ожидаемый объём и итог «от–до».',
    hours: 'Объём: {from} – {to} ч',
    vatIncluded: 'Цены с НДС {rate}',
    vatNone: 'НДС не облагается',
    switcher: 'Выберите пакет',
  },
  stages: {
    days: 'Рабочие дни {from}–{to}',
    result: 'Результат',
    ask: 'Вопрос по этапу',
    empty: 'В этом пакете этапов нет',
  },
  support: {
    intro:
      'Поддержка и развитие после запуска: часы каждый месяц на правки, обновления и небольшие доработки.',
    hours: '{hours} ч в месяц',
    month: 'Месяц',
    year: 'Год',
    perMonth: '{price} / мес',
    perYear: '{price} / год',
    saving: 'выгода {amount}',
    none: 'Не нужно',
    noneHint: 'Подключить поддержку можно и позже',
    burn: 'Неиспользованные часы переносятся и сгорают через {months}',
    noBurn: 'Неиспользованные часы не сгорают',
    burnHint: 'Часы, которые не потратили в месяце, переходят на следующие месяцы, пока не сгорят.',
    billingHint: 'Оплата вперёд: за месяц или сразу за год со скидкой.',
  },
  payment: {
    template: 'Порядок оплаты: {name}',
    whenSigning: 'при подписании договора',
    whenStage: 'при старте этапа «{stage}»',
    whenStagePlain: 'при старте этапа',
    whenLaunch: 'при запуске',
    whenMonthly: 'ежемесячно',
    total: 'Итого',
  },
  cases: {
    open: 'Смотреть проект',
  },
  manager: {
    call: 'Позвонить',
    write: 'Написать',
    ask: 'Задать вопрос',
  },
  actions: {
    select: 'Выбрать',
    selectPackage: 'Выбрать «{package}»',
    change: 'Изменить выбор',
    chosen: 'Ваш выбор',
    accepted: 'Предложение принято',
    decline: 'Не подходит',
    ask: 'Задать вопрос',
    undo: 'Отменить',
    supportOnly: 'Поддержка',
    total: '{package} · {total}',
    plusMonth: '+ {price} / мес',
    plusYear: '+ {price} / год',
    pickTariff: 'Выберите тариф поддержки',
  },
  thanks: {
    title: 'Спасибо!',
    body: '{manager} свяжется с вами, чтобы обсудить договор.',
    bodyStudio: 'Менеджер свяжется с вами, чтобы обсудить договор.',
    summary: 'Ваш выбор: {package}',
    support: 'Поддержка: {tariff}, {billing}',
    noSupport: 'Без поддержки',
    sending: 'Отправляем выбор…',
    locked:
      'Выбор зафиксирован. Если нужно что-то поменять, напишите менеджеру — он пришлёт обновлённое предложение.',
    billingMonth: 'помесячно',
    billingYear: 'за год',
  },
  declined: {
    title: 'Вы ответили: не подходит',
    reason: 'Причина: {reason}',
    again: 'Если передумаете — выберите пакет, предложение ещё действует.',
  },
  decline: {
    title: 'Что не подходит?',
    body: 'Подскажите причину — менеджер учтёт её и предложит другой вариант.',
    reasons: {
      expensive: 'Дорого',
      terms: 'Сроки не подходят',
      chose_others: 'Выбрали других',
      changed_mind: 'Передумали',
      other: 'Другое',
    },
    text: 'Комментарий (необязательно)',
    textRequired: 'Расскажите, что не так',
    send: 'Отправить',
    cancel: 'Закрыть',
  },
  ask: {
    placeholder: 'Ваш вопрос',
    send: 'Отправить вопрос',
    empty: 'Напишите вопрос — хотя бы пару слов',
  },
  chat: {
    title: 'Переписка с менеджером',
    empty:
      'Напишите вопрос — менеджер ответит здесь же. Если вас не будет на странице, ответ придёт на почту.',
    loading: 'Загружаем переписку…',
    preview: 'Это предпросмотр — переписка работает только по ссылке клиента.',
    placeholder: 'Ваш вопрос или сообщение',
    hint: 'Ответ появится здесь, а если вас не будет на странице — придёт на почту',
    stagePrefix: 'Этап «{stage}»: ',
    team: 'Команда',
    deleted: 'Сообщение удалено',
    edited: 'изменено',
    send: 'Отправить',
    sending: 'Отправляем…',
    close: 'Закрыть',
  },
  toasts: {
    selected: 'Выбор отправлен',
    declined: 'Ответ отправлен',
    previewOnly: 'Это предпросмотр — ответ не отправлен',
  },
  info: 'Подробнее',
  close: 'Закрыть',
  /** Публичная оферта студии: `kp.<домен>/offer` и `/offer/<n>`. */
  offer: {
    loading: 'Загружаем оферту…',
    kicker: 'Публичная оферта',
    version: 'Версия {n} от {date}',
    current: 'Действующая версия',
    outdated: 'Это прежняя версия оферты. Сейчас действует версия {n}.',
    openCurrent: 'Открыть действующую',
    versions: 'Все версии',
    versionLine: 'Версия {n}',
    versionDate: 'от {date}',
    pdf: 'Скачать PDF',
    pdfShort: 'PDF',
    notPublishedTitle: 'Оферта ещё не опубликована',
    notPublishedBody: 'Студия пока не опубликовала оферту. Спросите менеджера — он пришлёт документы.',
    versionNotFoundTitle: 'Такой версии нет',
    versionNotFoundBody: 'Проверьте номер версии в ссылке или откройте действующую оферту.',
  },
  /** Страница подписания пакета документов: `kp.<домен>/sign/<ключ>` (подпроект 4.2). */
  sign: {
    loading: 'Загружаем документы…',
    kicker: 'Документы на подпись',
    forParty: 'для {party} · от {date}',
    validUntil: 'Ссылка действует до {date}',
    documents: 'Документы',
    open: 'Открыть',
    download: 'Скачать',
    downloadSigned: 'Скачать подписанное',
    sheet: 'Лист подписания',
    hash: 'Хэш пакета SHA-256',
    peTitle: 'Подпись кодом из письма',
    peBody:
      'Это простая электронная подпись: вы смотрите документы, подтверждаете согласие и вводите одноразовый код из письма. Юридическую силу ей даёт соглашение сторон — условие о такой подписи есть в документах. После подписи документы не меняются: лист подписания хранит, кто, когда и что подписал.',
    sign: 'Подписать',
    signTitle: 'Подписать документы',
    signLead: 'Код придёт на {email}. Проверьте и папку «Спам».',
    agree: 'Согласен(на) подписать документы',
    agreeRequired: 'Подтвердите согласие — без него подписать нельзя',
    getCode: 'Получить код',
    codeSent: 'Код отправлен на {email}',
    codeLabel: 'Код из письма',
    codeHint: '6 цифр',
    confirm: 'Подписать',
    resend: 'Отправить код ещё раз',
    resendIn: 'Новый код — через {seconds} с',
    attemptsLeft: 'Осталось попыток: {count}',
    signing: 'Подписываем…',
    signedTitle: 'Документы подписаны',
    signedBody: 'Подписано {date}. Копии с листом подписания придут вам на почту.',
    waitingTitle: 'Документы у студии',
    waitingSignedBody: 'Вы подписали документы. Студия подпишет со своей стороны — копии придут на почту.',
    waitingBody: 'Студия ещё готовит документы. Как только очередь дойдёт до вас, придёт письмо.',
    declinedTitle: 'Вы отказались подписать',
    declinedBody: 'Причина: {reason}. Менеджер свяжется с вами.',
    revokedTitle: 'Ссылка отозвана',
    revokedBody: 'Эти документы больше не ждут подписи. Напишите менеджеру — он пришлёт актуальные.',
    expiredTitle: 'Срок ссылки истёк',
    expiredBody: 'Ссылка действовала до {date}. Напишите менеджеру — он продлит её.',
    ask: 'Задать вопрос',
    askTitle: 'Вопрос по документам',
    askBody: 'Менеджер ответит по почте или телефону.',
    askSent: 'Вопрос отправлен — менеджер скоро ответит',
    decline: 'Отказаться',
    declineTitle: 'Отказаться от подписи',
    declineBody: 'Напишите, что не так, — менеджер разберётся и предложит решение.',
    declinePlaceholder: 'Причина отказа',
    declineRequired: 'Напишите причину — хотя бы пару слов',
    declineSend: 'Отказаться',
    remarks: 'Есть замечания',
    remarksTitle: 'Замечания к акту',
    remarksBody:
      'Напишите, что не так с выполненной работой, — менеджер разберётся и пришлёт исправленный акт.',
    remarksPlaceholder: 'Что исправить',
    remarksRequired: 'Напишите замечания — хотя бы пару слов',
    remarksSend: 'Отправить замечания',
    remarksSentTitle: 'Замечания отправлены',
    remarksSentBody: 'Ваши замечания: {text}. Менеджер свяжется с вами и пришлёт исправленный акт.',
    manager: 'Ваш менеджер',
    contacts: 'Контакты студии',
    call: 'Позвонить',
    write: 'Написать',
    notFoundTitle: 'Ссылка не найдена',
    notFoundBody: 'Проверьте адрес из письма или попросите менеджера прислать ссылку ещё раз.',
    errorTitle: 'Не удалось загрузить документы',
  },
  workDays: {
    one: '{count} рабочий день',
    few: '{count} рабочих дня',
    many: '{count} рабочих дней',
    other: '{count} рабочего дня',
  },
  months: { one: '{count} месяц', few: '{count} месяца', many: '{count} месяцев', other: '{count} месяца' },
} as const;
